module.exports = __webpack_public_path__ + "img/hasrefund.d5886086.svg";